module["exports"] = [
  "Ds.",
  "Dk.",
  "Gg.",
  "Jln.",
  "Jr.",
  "Kpg.",
  "Ki.",
  "Psr."
];


/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/id_ID/address/street_prefix.js
 ** module id = 645
 ** module chunks = 0
 **/